/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_AttachmentsDTO } from '../models/Routemize_DTOs_AttachmentsDTO';
import type { Routemize_DTOs_CreateRequestsDTO } from '../models/Routemize_DTOs_CreateRequestsDTO';
import type { Routemize_DTOs_RequestAnswerDTO } from '../models/Routemize_DTOs_RequestAnswerDTO';
import type { Routemize_DTOs_RequestsDTO } from '../models/Routemize_DTOs_RequestsDTO';
import type { Routemize_DTOs_RequestSearchResponse_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_RequestSearchResponse_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1 } from '../models/Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1';
import type { Routemize_DTOs_SearchParameters_RequestSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_SearchParameters_RequestSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_UpdateRequestsDTO } from '../models/Routemize_DTOs_UpdateRequestsDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RequestsService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_RequestsDTO OK
     * @throws ApiError
     */
    public static postApiAppRequestsCreate(
        requestBody?: Routemize_DTOs_CreateRequestsDTO,
    ): CancelablePromise<Routemize_DTOs_RequestsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/requests/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppRequestsDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/requests/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_RequestAnswerDTO OK
     * @throws ApiError
     */
    public static getApiAppRequestsGetAnswers(
        requestId: string,
    ): CancelablePromise<Array<Routemize_DTOs_RequestAnswerDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/requests/getAnswers/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns Routemize_DTOs_AttachmentsDTO OK
     * @throws ApiError
     */
    public static getApiAppRequestsGetAttachements(
        requestId: string,
    ): CancelablePromise<Array<Routemize_DTOs_AttachmentsDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/requests/getAttachements/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_RequestsDTO OK
     * @throws ApiError
     */
    public static getApiAppRequestsGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_RequestsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/requests/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_RequestSearchResponse_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static postApiAppRequestsSearch(
        requestBody?: Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/requests/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_RequestsDTO OK
     * @throws ApiError
     */
    public static putApiAppRequestsUpdate(
        requestBody?: Routemize_DTOs_UpdateRequestsDTO,
    ): CancelablePromise<Routemize_DTOs_RequestsDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/requests/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestId
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppRequestsUploadFiles(
        requestId: string,
        formData?: {
            Files?: Array<Blob>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/requests/uploadFiles/{requestId}',
            path: {
                'requestId': requestId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param bookingFormId
     * @param email
     * @param phoneNumber
     * @returns Routemize_DTOs_RequestsDTO OK
     * @throws ApiError
     */
    public static getApiAppRequestsGetPendingRequestByBookingFormAndContact(
        bookingFormId: string,
        email?: string,
        phoneNumber?: string,
    ): CancelablePromise<Routemize_DTOs_RequestsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/requests/getPendingRequestByBookingFormAndContact/{bookingFormId}',
            path: {
                'bookingFormId': bookingFormId,
            },
            query: {
                'email': email,
                'phoneNumber': phoneNumber,
            },
        });
    }
}
